import React, { Fragment } from "react";
import { useTranslation } from "@1f/react-sdk";

//Vapor Components
import Stack from "@vapor/react-material/Stack";
import Box from "@vapor/react-material/Box";
import Button from "@vapor/react-material/Button";
import Modal from "@vapor/react-material/Modal";
import Divider from "@vapor/react-material/Divider";

import ExtendedTypography from "@vapor/react-extended/ExtendedTypography";

export const ModalPrivateAlert = ({ show, onClose, onOk, pendingPrivateValue, fascicoloName }) => {
  const { t } = useTranslation();

  //Actions
  const handleModalClose = (e) => {
    onClose(e);
  };
  const handleModalOk = (e) => {
    onOk(e);
  };

  return (
    <Fragment>
      <Modal
        key="privateConfirmModal"
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        open={show}
        onClose={handleModalClose}
        onBackdropClick={handleModalClose}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "500px",
            minHeight: "200px",
            bgcolor: "#FFFFFF",
            boxShadow: "0px 0px 8px 0px #CCCCCC",
          }}
        >
          <Stack
            direction="column"
            spacing={0}
            justifyContent="left"
            alignItems="left"
          >
            <ExtendedTypography
              variant="titleSmall"
              color="primary.main"
              sx={{ p: 2, pl: 3 }}
            >
              {pendingPrivateValue
                ? `Vuoi rendere privato il fascicolo ${fascicoloName}?`
                : `Vuoi rendere pubblico il fascicolo ${fascicoloName}?`}
            </ExtendedTypography>
            <Divider orientation="horizontal" flexItem />
            <ExtendedTypography variant="subtitle2" sx={{ p: 2, pl: 3, pt: 3 }}>
              {pendingPrivateValue
                ? "Stai per rendere questo fascicolo privato. Solo tu potrai visualizzarlo e modificarlo, indipendentemente dai soggetti che hanno identificato le anagrafiche contenute. Confermi l'operazione?"
                : "Stai per rendere questo fascicolo pubblico. Tutti gli utenti autorizzati potranno visualizzarlo. Confermi l'operazione?"}
            </ExtendedTypography>
          </Stack>
          <Stack
            direction="row"
            spacing={1}
            sx={{ p: 1, mt: 1, bgcolor: "#F2F5F8" }}
            justifyContent="right"
            alignItems="right"
          >
            <Button variant="outlined" size="small" onClick={handleModalClose}>
              {t("actions.annulla")}
            </Button>
            <Button variant="contained" size="small" onClick={handleModalOk}>
              Conferma
            </Button>
          </Stack>
        </Box>
      </Modal>
    </Fragment>
  );
};
